import { findStudent, studentsLength } from '@/store/students/getters'
import { del, get, getAll, patch, post } from '@/utils/api'

const normalizeStudent = record => ({
  id: record.getId(),
  name: record.get('name'),
  grade: record.get('grade')
})

const getStudents = ({ commit, state }, force) => {
  if (studentsLength(state) < 1 || !!force) {
    getAll('Students').then(students => {
      const returnStudents = students.map(s => normalizeStudent(s))
      commit('SET_STUDENTS', returnStudents)
      commit('IS_LOADED')
    })
  }
}

const getStudent = ({ commit }, id) => {
  const studentFromState = findStudent(id)
  if (studentFromState) {
    return studentFromState
  }

  get('Students', id).then(student => {
    commit('SET_STUDENT', normalizeStudent(student))
  })
}

const addStudent = ({ commit }, student) => {
  post('Students', { fields: student }).then(students => {
    students.forEach(s => {
      commit('ADD_STUDENT', normalizeStudent(s))
    })
  })
}

const deleteStudent = ({ commit }, id) => {
  del('Students', id).then(s => {
    commit('DELETE_STUDENT', s.id)
  })
}

const editStudent = ({ commit }, student) => {
  patch('Students', student).then(s => {
    commit('EDIT_STUDENT', normalizeStudent(s))
  })
}

export default {
  addStudent,
  deleteStudent,
  editStudent,
  getStudent,
  getStudents
}
